import { createFileRoute, Link } from "@tanstack/react-router";
import { isNative } from "@/lib/nativeAuth";
import { useSeo } from "@/lib/seo";
import { TermsContent } from "@/components/legal/TermsContent";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});

function TermsPage() {
  useSeo({
    title: "Terms of Use | GreenTrack",
    description: "The terms and license governing your use of GreenTrack, including subscriptions, disclaimers, and the fact that GreenTrack is not legal advice.",
    path: "/terms",
  });

  return (
    <div className="min-h-screen bg-paper text-ink">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:px-10 sm:py-24">
        <Link
          to={isNative() ? "/app" : "/"}
          className="text-[10px] font-bold uppercase tracking-widest text-ink-muted hover:text-ink-deep"
        >
          ← Back to GreenTrack
        </Link>

        <div className="mt-8">
          <TermsContent />
        </div>
      </div>
    </div>
  );
}
